/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PostPutShiftSettingRequestAdmin } from '../models/PostPutShiftSettingRequestAdmin';
import type { ShiftSettingAdminDto } from '../models/ShiftSettingAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShiftSettingsService {
    /**
     * **Required Policy:** `ManageShiftSettings`
     * @returns ShiftSettingAdminDto OK
     * @throws ApiError
     */
    public static postShiftSettingAdmin({
        requestBody,
    }: {
        requestBody?: PostPutShiftSettingRequestAdmin,
    }): CancelablePromise<ShiftSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shiftsettings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShiftSettings`
     * @returns ShiftSettingAdminDto OK
     * @throws ApiError
     */
    public static getShiftSettingAdmin(): CancelablePromise<ShiftSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shiftsettings',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
